// extracted by mini-css-extract-plugin
module.exports = {"login-redirection__link":"_3VxXX","login-redirection":"_3PthV","welcome__headline":"_2p6Vo","welcome__subline":"_2Cbvr"};